<template>
  <v-row>
    <v-col>
      <Allergy
        :attendance="attendance"
        :showForm="false"
        :allowDelete="false"
      />

      <SurgeryDetail :surgery="surgery" />

      <ProsthesisList
        :surgeryIndicationProstheses="surgery.surgeryIndication.prostheses"
        :surgeryIndication="surgery.surgeryIndication"
        :showForm="false"
        :onlyChosen="true"
        :allowDelete="false"
        :allowEdit="false"
        @update-surgery-indication-prostheses="updateProstheses"
      />

      <v-row>
        <v-col class="text-h5 gray--text"> Equipe </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="6">
          <v-combobox
            label="Cirurgião"
            v-model="surgeon"
            dense
            hide-details
            outlined
            :items="doctorUsers"
            item-text="employee.name"
            background-color="white"
            @change="debouncedSave"
            :disabled="disabled"
          />
        </v-col>

        <v-col cols="6">
          <v-combobox
            label="Farmacêutico"
            v-model="pharmaceutical"
            dense
            hide-details
            outlined
            :items="pharmaceuticalUsers"
            item-text="employee.name"
            background-color="white"
            @change="debouncedSave"
            :disabled="disabled"
          />
        </v-col>

        <v-col cols="6">
          <v-combobox
            label="Instrumentador"
            v-model="instrumentator"
            dense
            hide-details
            outlined
            :items="nurseUsers"
            item-text="employee.name"
            background-color="white"
            @change="debouncedSave"
            :disabled="disabled"
          />
        </v-col>

        <v-col cols="6">
          <v-combobox
            label="Circulante"
            v-model="floating"
            dense
            hide-details
            outlined
            :items="nurseUsers"
            item-text="employee.name"
            background-color="white"
            @change="debouncedSave"
            :disabled="disabled"
          />
        </v-col>

        <v-col cols="6">
          <v-combobox
            label="Auxiliares"
            v-model="assistants"
            dense
            hide-details
            outlined
            :items="doctorUsers"
            item-text="employee.name"
            multiple
            chips
            deletable-chips
            small-chips
            background-color="white"
            @change="debouncedSave"
            :disabled="disabled"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-row dense>
            <v-col class="text-h5 gray--text"> Descrição </v-col>
          </v-row>

          <v-row dense>
            <v-col>
              <v-combobox
                label="Cirurgia"
                v-model="descriptionModel"
                dense
                hide-details
                outlined
                :items="descriptionModels"
                item-text="name"
                background-color="white"
                :disabled="disabled"
              />
            </v-col>

            <v-col>
              <v-combobox
                label="Modelo"
                v-model="descriptionTemplate"
                dense
                hide-details
                outlined
                :items="descriptionModelTemplates"
                item-text="name"
                background-color="white"
                @change="choseDescriptionTemplate"
                :disabled="disabled"
              />
            </v-col>
          </v-row>

          <v-row dense>
            <v-col>
              <RichText
                v-model="description"
                @change="debouncedSave"
                :disabled="disabled"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col class="text-h5 gray--text"> Anexos Cirurgia </v-col>
      </v-row>

      <v-row dense>
        <v-col>
          <FileUpload
            ownerType="Surgery::Intraoperative"
            :ownerId="surgery.intraoperative.id"
            :disabled="disabled"
          />
        </v-col>
      </v-row>

      <SurgeryProsthesisList
        :surgery="surgery"
        :refreshProstheses="refreshSurgery"
        :disabled="disabled"
      />

      <SurgeryIntraoperativeAnesthesia
        :attendance="attendance"
        :surgery="surgery"
        :refreshSurgery="refreshSurgery"
        :doctorUsers="doctorUsers"
        :nurseUsers="nurseUsers"
        :disabled="disabled"
      />

      <SurgeryVitalMeasurementList
        :surgery="surgery"
        :refreshSurgery="refreshSurgery"
        :surgeryMoment="surgeryMoment"
        :disabled="disabled"
      />

      <SurgeryTherapyList
        :surgery="surgery"
        :refreshSurgery="refreshSurgery"
        :surgeryMoment="surgeryMoment"
        :disabled="disabled"
      />

      <v-row>
        <v-col>

      <v-row dense>
        <v-col class="text-h5 gray--text"> Notas </v-col>
      </v-row>

        <RichText
          v-model="observation"
          @change="debouncedSave"
          :disabled="disabled"
        />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import ProsthesisList from "@/components/surgery_indication/prosthesis/list/index.vue";
import Allergy from "@/components/medical_record/hpp/allergy.vue";
import SurgeryDetail from "@/components/surgery/detail.vue";
import SurgeryIntraoperativeAnesthesia from "@/components/surgery/intraoperative/anesthesia.vue";
import SurgeryProsthesisList from "@/components/surgery/intraoperative/prosthesis/list/index.vue";
import SurgeryVitalMeasurementList from "@/components/surgery/vital_measurement/list/index.vue";
import SurgeryTherapyList from "@/components/surgery/therapy/list/index.vue";

export default {
  name: "SurgeryIntraoperative",
  props: {
    surgery: Object,
    refreshSurgery: Function,
    setSurgeryMoment: Function,
    surgeryMoment: String,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ProsthesisList,
    Allergy,
    SurgeryDetail,
    SurgeryIntraoperativeAnesthesia,
    SurgeryProsthesisList,
    SurgeryVitalMeasurementList,
    SurgeryTherapyList,
  },
  data() {
    return {
      surgeon: null,
      pharmaceutical: null,
      floating: null,
      instrumentator: null,
      assistants: [],
      description: "",
      observation: "",
      descriptionModel: null,
      descriptionTemplate: null,
    };
  },
  created() {
    this.debouncedSave = this.lodash.debounce(
      this.saveSurgeryPreoperative,
      2000
    );
  },
  mounted() {
    this.description = this.intraoperative.description;
    this.observation = this.intraoperative.observation;
    this.setSurgeryMoment("intraoperative");

    this.loadUsers();
  },
  apollo: {
    users: {
      query: require("@/graphql/users.gql"),
      result() {
        this.loadUsers();
      },
    },
    surgeryIntraoperativeSurgeryTemplates: {
      query: require("@/graphql/surgery/surgery_intraoperative_surgery_templates.gql"),
    },
  },
  computed: {
    attendance() {
      return this.surgery.attendance;
    },
    intraoperative() {
      return this.surgery.intraoperative;
    },
    doctorUsers() {
      return this.lodash.orderBy(
        this.lodash.filter(this.users, {
          employee: { employeeType: "doctor" },
        }),
        [
          (e) =>
            e.employee.name
              .toLowerCase()
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, ""),
        ],
        ["asc"]
      );
    },
    nurseUsers() {
      return this.lodash.orderBy(
        this.lodash.filter(this.users, {
          employee: { employeeType: "nurse" },
        }),
        [
          (e) =>
            e.employee.name
              .toLowerCase()
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, ""),
        ],
        ["asc"]
      );
    },
    pharmaceuticalUsers() {
      return this.lodash.filter(this.users, {
        employee: { employeeType: "pharmaceutical" },
      });
    },
    descriptionModels() {
      return this.lodash.uniqBy(
        this.lodash.map(this.surgeryIntraoperativeSurgeryTemplates, "surgery"),
        "id"
      );
    },
    descriptionModelTemplates() {
      if (this.descriptionModel?.id) {
        return this.lodash.filter(
          this.surgeryIntraoperativeSurgeryTemplates,
          function (e) {
            return e.surgery.id === this.descriptionModel.id;
          }.bind(this)
        );
      }

      return [];
    },
  },
  methods: {
    loadUsers() {
      if (this.intraoperative.surgeon?.id) {
        this.surgeon = this.lodash.find(this.doctorUsers, {
          id: this.intraoperative.surgeon.id,
        });
      }

      if (this.intraoperative.pharmaceutical?.id) {
        this.pharmaceutical = this.lodash.find(this.pharmaceuticalUsers, {
          id: this.intraoperative.pharmaceutical.id,
        });
      }

      if (this.intraoperative.floating?.id) {
        this.floating = this.lodash.find(this.nurseUsers, {
          id: this.intraoperative.floating.id,
        });
      }

      if (this.intraoperative.instrumentator?.id) {
        this.instrumentator = this.lodash.find(this.nurseUsers, {
          id: this.intraoperative.instrumentator.id,
        });
      }

      this.assistants = this.lodash.filter(
        this.doctorUsers,
        function (e) {
          return this.lodash
            .map(this.intraoperative.assistants, "id")
            .includes(e.id);
        }.bind(this)
      );
    },
    saveSurgeryPreoperative() {
      if (this.disabled) return;

      this.descriptionModel = null;
      this.descriptionTemplate = null;

      return this.apolloMutate({
        mutation: require("@/graphql/surgery/save_surgery_intraoperative.gql"),
        variables: {
          surgeryId: this.surgery.id,
          surgeonId: this.lodash.get(this.surgeon, "id", ""),
          pharmaceuticalId: this.lodash.get(this.pharmaceutical, "id", ""),
          floatingId: this.lodash.get(this.floating, "id", ""),
          instrumentatorId: this.lodash.get(this.instrumentator, "id", ""),
          description: this.description,
          observation: this.observation,
          assistantIds: this.lodash.map(this.assistants, "id"),
        },
      }).then(() => {
        this.refreshSurgery();
      });
    },
    choseDescriptionTemplate() {
      if (this.descriptionTemplate?.description) {
        if (!this.description) {
          this.description = this.descriptionTemplate.description;
        } else {
          this.description += "\n";
          this.description += this.descriptionTemplate.description;
        }

        this.debouncedSave();
      }
    },
    updateProstheses(prostheses) {
      this.surgery.surgeryIndication.prostheses = prostheses;
    },
  },
};
</script>

<style lang="scss" scoped></style>
